import { useContext } from 'react';
import { BrowserHistoryContext } from './BrowserHistory';

export default () => useContext(BrowserHistoryContext);
